import React from 'react'
import {Icon} from '../../../library/decor/SarasIcons';
import SarasTooltip from '../../notifications/SarasTooltip';
import SarasPopup from '../../container/popup/SarasPopup';
import * as fn from '../../../helper/uiFunctions';

const FormLink = (props) => {
    //this should be default format for reading props for all form controls
    const { formObject, action, rowKey, maxValueLength, useValF, headerKey, qvIconKey, linkProp, className, children, anchorStyle, text } = props;
    // console.log('data', rowKey, action.paramName, formObject);

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const hideQV = formObject.getValueFromKey(viewData, "dataList.isHidQV", "0");
    const isUrl = formObject.getValueFromKey(viewData, "dataList.isUrl", "0");
    const cssClass = formObject.getValueFromKey(viewData, "dataList.colCssClass", "");
    const isRO = formObject.getValueFromKey(viewData, "dataList.isRO", "0");

    const [quickViewData, setQuickViewData] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    //for efficiency: request for popup data only for the first time
    //and then store it in the state to use it for next mouse enter event
    const onOpenQV = (e) => {
        // console.log("debug bom 1", quickViewData);

        if(!quickViewData){
            let customAction = {...action, skipMasterKey: 1, onSuccess: onSuccess};
            // console.log("debug bom 2", customAction);

            if (!customAction.actionParam) {
                customAction["actionParam"] = {};
            }

            customAction.actionParam["dtId"] = viewData.dataList.valLDT;
            customAction.actionParam["dId"] = viewData.val;

            if (customAction.actionId) formObject.onFormAction(customAction, rowKey, headerKey);
        }
        else{
            // console.log("quick view from memory");
            setOpen(true);
        }
    }

    const onCloseQV = (e) => {
        // console.log("mouse left");
        setOpen(false);
    }

    const onSuccess = (action, containerKey, rowKey, headerKey, response) => {
        //  console.log("quick view data received successfully, run code to show the popup", response);
        setOpen(true);
        setQuickViewData(response);
    }

    const renderQuickView = () => {
        // console.log("quick view generator", quickViewData, open);
        if(quickViewData && open){
            let DynamicComponent = formObject.getDynamicView(quickViewData.viewKey);

            if(DynamicComponent){
                // console.log("debug 3", quickViewData.viewKey, formObject);
                return (
                    <SarasPopup anchorRef={anchorRef} open={open} placement="right" onClose={onCloseQV}>
                        <DynamicComponent viewMap={formObject.viewMap} 
                        triggerType={quickViewData.viewData.viewType === "c" ? "custom" : ""}
                        viewData={quickViewData.viewData}></DynamicComponent>
                    </SarasPopup>
                );
            }
        }

        return null;
    }

    const renderQuickViewTrigger = () => {
        if (action.actionParam && action.actionParam.showModeID === "qv" && hideQV === "0") {
            const QvIcon = Icon[qvIconKey || "describe"];

            if(QvIcon){
                return (
                    <span ref={anchorRef} onClick={onOpenQV}
                        className="uiLink">
                        <QvIcon style={{margin:'0px 5px 0px 0px',color:'#737171'}}/>
                        {renderQuickView()}
                    </span>
                )
            }
        }

        return null;
    }

    const getValue = () => {
        if(text){
            return {value: text, title: ""};
        }
        else{
            let value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || (useValF ? viewData.valF : viewData.val));
            let title = '';
            
            if(maxValueLength && value.length > maxValueLength){
                title = value;
                value = value.substring(0, maxValueLength) + " ...";
            }
    
            return {value: value, title: title};
        }
    }

    if (viewData && hide === "0"){
        //build the url for link
        let url = "";
        let displayValue = getValue();

        if(fn.compareNumber(isUrl, 0))
        {
            url = fn.getShowDocumentLink(viewData.dataList.valLDT, viewData.val, "", 1,
            formObject.getValueFromKey(action, "actionParam.module", viewData.dataList.module),
            formObject.getValueFromKey(action, "actionParam.view", viewData.dataList.view));
        }
        else
        {
            url = viewData.val;
        }

        if(fn.compareNumber(isRO, 1)) {
            return (<span>{getValue()}</span>)
        }
        else{
            return (
                <>
                    {renderQuickViewTrigger()}
                    <SarasTooltip title={displayValue.title || ''}>
                        <a className={className || cssClass || "uiLink"} style={anchorStyle} href={url} {...linkProp}>{children || displayValue.value}</a>
                    </SarasTooltip>
                </>
            )
        }
    }

    return (null);
}

export default FormLink;
